<template>
  <div class="v-face" @click="showFace">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      bizId: {
        type: String,
        default: ''
      }
    },
    methods: {
      showFace() {
        const params = {
          verifyCode: '800011',
          bizId: this.bizId
        }
        if (window.CONFIG.testPin) {
          params.pin = window.CONFIG.testPin;
        }
        window.initJdIvep(
          params,
          (obj) => {
            const status = obj.getStatus();
            switch (status) {
              case 1:// 成功
                const serialId = obj.getSerialId();
                const ivepResult = obj.getIvepResult();
                this.$emit('confirm', {
                  serialId,
                  ivepResult
                });
                break;
                
              case 2:// 客户端不支持
                this.$vDialog.show('当前环境不支持刷脸，请前往最新版本京东或京东金融app进行开通');
                break;
                
              case 5:// 对比失败(重试超过次数)
                this.$vDialog.show("您当前认证失败次数过多，请稍后再试");
                break;
                
              case 4:// 用户取消
                break;
              
              case 3:// 无网纹照
              case 6:// 超时
              case 7:// 其他异常
              default:
                this.$vDialog.show(window.CONFIG.error);
            }
          }
        );
      }
    },
    mounted() {
      this.$on('show', this.showFace);
    }
  };
</script>